export default function SnsButton({ icon, label, variant = 'kakao', onClick, disabled }) {
  const variants = {
    kakao: 'bg-[#FEE500] text-[rgba(0,0,0,0.85)]',
    google: 'bg-[#F2F4F6] text-[rgba(0,0,0,0.85)]',
    apple: 'bg-white text-black',
  };

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`relative flex h-[53px] w-full items-center justify-center rounded-[10px] border-0 px-5 font-['Pretendard'] text-[16px] font-bold outline-none disabled:opacity-60 ${variants[variant] || variants.kakao}`}
    >
      <span className="absolute left-[21px] top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center">
        {typeof icon === 'string' ? <img src={icon} alt="" width={18} height={18} /> : icon}
      </span>
      <span>{label}</span>
    </button>
  );
}
